import moment from "moment";
import { checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";

export function getAllowedTeamIds(ids) {
    return ids.filter(id => checkPermission(config.scopes.evaluations, config.permissionTypes.view, id));
}

export function getRatioColor(yesCount, noCount) {
    if (yesCount + noCount === 0) return '#bcbcbc';
    const ratio = (yesCount / (yesCount + noCount)) * 100;
    if (ratio <= 25) return '#FF0000';
    if (ratio <= 50) return '#ED7D31';
    if (ratio < 100) return '#FFFF00';
    if (ratio === 100) return '#70AD47';
    return '#bcbcbc';
}

export function getTeamMonthData(summaryData, teamId, month) {
    if (!teamId || !summaryData) return undefined;
    const teamData = summaryData.find(t => t.id_team === teamId);
    return teamData?.[month] ?? "No data available";
}

export function convertReportsToArray(reports, year) {
    const reportsArray = [];
    Object.entries(reports).forEach(([idCollab, report]) => {
        const modifiedReport = { ...report, id_collab: parseInt(idCollab, 10) };
        const exitDate = moment(modifiedReport.sortie_date).format("YYYY-MM-DD");
        const nowDate = moment([year - 1, 11, 30]).format("YYYY-MM-DD");
        if (modifiedReport.sortie_date) {
            if (moment(nowDate).isBefore(exitDate, 'year')) {
                reportsArray.push(modifiedReport);
            }
        } else {
            reportsArray.push(modifiedReport);
        }
    });
    return reportsArray;
}

export function processReports(reports, year) {
    return reports.map(report => {
        const processedReport = {
            nom: report.nom,
            prenom: report.prenom,
            id_team: report.id_team,
            team_name: report.team_name,
            id_collab: report.id_collab,
            matricule: report.matricule,
            flaggedMonths: [],
        };

        Object.keys(report.data).forEach(month => {
            const yesCount = report.data[month]['yes'] || 0;
            const noCount = report.data[month]['no'] || 0;
            const ratio = (yesCount + noCount === 0)
                ? "no evaluation"
                : ((yesCount / (yesCount + noCount)) * 100).toFixed(2);

            if (report.data[month].flag) {
                processedReport.flaggedMonths.push(month);
            }

            const monthEnd = moment({ year, month: month - 1, day: 1 }).endOf('month');
            const entreeDate = report.entree_date ? moment(report.entree_date) : moment('1900-01-01');
            const exitDate = report.sortie_date ? moment(report.sortie_date) : moment('2200-01-01');

            if (monthEnd.isAfter(entreeDate) && monthEnd.isBefore(exitDate)) {
                processedReport[month] = ratio;
            }
        });

        return processedReport;
    });
}

export function summarizeReports(processedReports) {
    const teamSummaries = {};

    processedReports.forEach(report => {
        const { team_name: teamName, id_team: teamId } = report;
        if (!teamSummaries[teamName]) {
            teamSummaries[teamName] = { id_team: teamId, data: {} };
        }
        Object.keys(report).forEach(key => {
            if (['nom', 'prenom', 'id_team', 'team_name', 'id_collab'].includes(key)) return;
            if (!teamSummaries[teamName].data[key]) {
                teamSummaries[teamName].data[key] = { evaluated: 0, total: 0 };
            }
            teamSummaries[teamName].data[key].total++;
            if (report[key] !== "no evaluation") {
                teamSummaries[teamName].data[key].evaluated++;
            }
        });
    });

    return Object.entries(teamSummaries).map(([team, teamInfo]) => ({
        team_name: team,
        id_team: teamInfo.id_team,
        ...Object.fromEntries(
            Object.entries(teamInfo.data).map(([month, data]) => [month, `${data.evaluated}/${data.total}`])
        ),
    }));
}
